import { ModuleHeader } from "@nabble/ui";
import { useLocation, useNavigate } from "react-router-dom";
import type { AppModule } from "./appModules";
import { isSectionPage } from "./navigation";

interface SectionHeaderProps {
  module: AppModule;
  activeSectionId: string | undefined;
}

/** The module's header and section tabs, only on a section's own page: detail pages (a board, a vault, a card) start at their title. */
export function SectionHeader({ module, activeSectionId }: SectionHeaderProps): React.JSX.Element | null {
  const navigate = useNavigate();
  const location = useLocation();
  if (!isSectionPage(module, location.pathname)) return null;
  return (
    <ModuleHeader
      icon={module.icon}
      title={module.label}
      description={module.description}
      // A module with a single section needs no tab row: the header already names it.
      tabs={module.sections.length > 1 ? module.sections.map((sec) => ({ id: sec.id, label: sec.label, href: sec.path, icon: sec.icon })) : []}
      active={activeSectionId}
      onNavigate={(href) => navigate(href)}
    />
  );
}
